export default "__VITE_ASSET__Cx8bH1Bk__"